export const POSTHOG_PROJECT_TOKEN = process.env.REACT_APP_POSTHOG_PROJECT_TOKEN;
export const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST;
